module.exports = __webpack_public_path__ + "a81b69d01bead844aea72c9af831ffae.pdf";